export const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(0,0,0, 0.4)',
    zIndex: '10',
  },
  content: {
    borderRadius: '8px',
    width: '552px',
    maxWidth: '90vw',
    maxHeight: '90vh',
    padding: '32px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};
